import { Component, OnInit, Input } from '@angular/core';
import { exploitations } from '../../../shared/constants/exploitations';
import { objectives } from '../../../shared/constants/objectives';
import { FormGroup, FormControl, FormArray, FormBuilder } from '@angular/forms';
import { FarmService } from '../farm.service';
import { LocationService } from '../location.service';
import { Province } from 'src/app/shared/dtos/Province';
import { TownHall } from 'src/app/shared/dtos/TownHall';
import { MapService } from '../map.service';
import { District } from 'src/app/shared/dtos/District';
import { Municipality } from 'src/app/shared/dtos/Municipality';

@Component({
  selector: 'app-filter-farms',
  templateUrl: './filter-farms.component.html',
  styleUrls: ['./filter-farms.component.css']
})
export class FilterFarmsComponent implements OnInit {

  data_exploitation = exploitations;
  data_objectives = objectives;

  @Input() params: FormGroup;
  @Input() isCreated: boolean;
  @Input() onSubmit;
  townHallDisable = true;
  municipalityDisable = true;

  areaMin = 0;
  areaMax = 0;

  provinces: Province [];
  townHalls: TownHall [];

  districts: District [];
  municipalities: Municipality [];

  constructor(private locationService: LocationService, private farmService: FarmService, private mapService: MapService) { }

  ngOnInit() {
    this.getProvinces();
    this.getDistricts();
  }

  onChangeProvince(event) {
    const idProvince = event.value;
    this.locationService.getTownHallsByIdProvince(idProvince)
      .subscribe(townHalls => this.townHalls = townHalls);
    this.townHallDisable = false;
  }

  onSelectedTownHall(townHall: TownHall) {
    this.params.get('townHall').setValue(townHall.idTownHall);
    this.mapService.setLocationFilter(townHall);
 }

  onChangeDistrict(event) {
    const idDistrict = event.value;
    this.locationService.getMunicipalitiesByIdDistricts(idDistrict)
      .subscribe(municipalities => this.municipalities = municipalities);
    this.municipalityDisable = false;
  }

  onSelectedMunicipality(municipality: Municipality) {
    this.params.get('municipality').setValue(municipality.idMunicipality);
    this.mapService.setLocationPortugalFilter(municipality);
    // this.mapService.setLocationFilter(townHall);
 }

 resetLocations(){
   this.params.get('province').reset();
   this.params.get('townHall').reset();
   this.params.get('district').reset();
   this.params.get('municipality').reset();
 }

  onChange(event, nameCheckbox) {
    const checkbox = <FormArray>this.params.get(nameCheckbox) as FormArray;
    if (event.checked) {
      checkbox.push(new FormControl(event.source.value.type));
    } else {
     const i = checkbox.controls.findIndex(x => x.value === event.source.value.type);
     checkbox.removeAt(i);
    }
  }

  resetForm() {
   this.params.reset();
   this.params.controls.exploitations.reset();
  }

  getProvinces() {
    this.locationService.getProvincesSpain()
      .subscribe( provinces => this.provinces = provinces);
  }

  getDistricts() {
    this.locationService.getDistrictsPortugal()
      .subscribe(districts => this.districts = districts);
  }

  getCountries() {
    return this.farmService.getCountries();
  }

  getCountryDefault() {
    return this.getCountries()[0].id;
  }

  compareFunction(o1: any, o2: any) {
    return (o1.id === o2.id && o1.cod === o2.cod && o1.country === o2.country);
  }

  onEnterArea(event) {
    const areaMin = this.params.get('areaMin').value;
    const areaMax = this.params.get('areaMax').value;
    if (areaMax < areaMin) {
      this.params.get('areaMin').setValue(0);
      this.params.get('areaMax').setValue(event.target.value);
    }
  }

 }
